let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l7ce6")).then(() => parcelRequire('lB7uF'));